var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[(_vm.props.value)?_c('span',{class:_vm.props.col && _vm.props.col.iconClass},[_c('i',{class:'fa fa-fw fa-' + (_vm.props.col && _vm.props.col.icon || 'check')})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }